import React, { useState, useEffect } from "react";
import axios from "axios";
import _ from "lodash";
import { services } from "../services";
import DataTable from "react-data-table-component";
import { FaEdit } from "react-icons/fa";

const CreateUpdatePartner = () => {
  const [formData, setFormData] = useState({
    name: "",
    organizationCategory: "",
    addressCountry: "",
    addressState: "",
    addressDistrict: "",
    addressLocation: "",
    addressHouseNumber: "",
    addressCityTown: "",
    pinCode: "",
    aboutPartner: "",
    activationStartDate: new Date().toISOString().split("T")[0],
    activationEndDate: new Date().toISOString().split("T")[0],
    contactPersonName: "",
    contactPersonEmail: "",
    contactPersonMobileNumber: "",
    organisationHeadName: "",
    organisationHeadEmail: "",
    organisationHeadMobileNumber: "",
    logoFile: null,
    active: false,
    skillstrainerPartnerId: "",
  });
  const [partnersList, setPartnersList] = useState([]);
  const [editingPartner, setEditingPartner] = useState(null);
  const [popup, setPopup] = useState({ show: false, message: "" });

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? e.target.checked : value,
    }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      logoFile: e.target.files[0],
    }));
  };

  const handlePincodeChange = async (e) => {
    const pinCode = e.target.value;
    setFormData((prev) => ({ ...prev, pinCode }));

    if (pinCode.length === 6) {
      try {
        const res = await axios.get(
          `https://api.postalpincode.in/pincode/${pinCode}`
        );
        const locationData = _.get(res.data, "0.PostOffice.0");
        if (locationData) {
          setFormData((prev) => ({
            ...prev,
            addressState: locationData.State,
            addressDistrict: locationData.District,
            addressCityTown: locationData.Name,
            addressCountry: locationData.Country,
          }));
        }
      } catch (error) {
        console.error("Failed to fetch location from pincode");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let logoFileId = undefined;
    if (formData.logoFile) {
      const formDataUpload = new FormData();
      formDataUpload.append("file", formData.logoFile);
      const uploadResp = await services.requestSvc.post(
        "/upload-file",
        formDataUpload
      );
      logoFileId = uploadResp.id;
    }

    const payload = {
      name: formData.name,
      organizationCategory: formData.organizationCategory,
      addressCountry: formData.addressCountry,
      addressState: formData.addressState,
      addressDistrict: formData.addressDistrict,
      addressLocation: formData.addressLocation,
      addressHouseNumber: formData.addressHouseNumber,
      addressCityTown: formData.addressCityTown,
      pinCode: formData.pinCode,
      aboutPartner: formData.aboutPartner,
      activationStartDate: new Date(formData.activationStartDate).toISOString(),
      activationEndDate: new Date(formData.activationEndDate).toISOString(),
      contactPersonName: formData.contactPersonName,
      contactPersonEmail: formData.contactPersonEmail,
      contactPersonMobileNumber: formData.contactPersonMobileNumber,
      organisationHeadName: formData.organisationHeadName,
      organisationHeadEmail: formData.organisationHeadEmail,
      organisationHeadMobileNumber: formData.organisationHeadMobileNumber,
      logoFileId,
      active: formData.active,
      skillstrainerPartnerId: Number(formData.skillstrainerPartnerId) || null,
    };

    try {
      let res;
      if (editingPartner) {
        res = await services.requestSvc.post("/update-partner", {
          ...payload,
          id: editingPartner?.id,
        });
        setPopup({ show: true, message: "Partner updated successfully" });
      } else {
        res = await services.requestSvc.post("/create-partner", payload);
        setPopup({ show: true, message: "Partner created successfully" });
      }
      if (res) {
        setPartnersList((prevList) => [res, ...prevList]);
      }

      setFormData({
        name: "",
        organizationCategory: "",
        addressCountry: "",
        addressState: "",
        addressDistrict: "",
        addressLocation: "",
        addressHouseNumber: "",
        addressCityTown: "",
        pinCode: "",
        aboutPartner: "",
        activationStartDate: new Date().toISOString().split("T")[0],
        activationEndDate: new Date().toISOString().split("T")[0],
        contactPersonName: "",
        contactPersonEmail: "",
        contactPersonMobileNumber: "",
        organisationHeadName: "",
        organisationHeadEmail: "",
        organisationHeadMobileNumber: "",
        logoFile: null,
        active: false,
        skillstrainerPartnerId: "",
      });

      setEditingPartner(null);
    } catch (error) {
      console.error("Error creating partner", error);
      setPopup({ show: true, message: "Error creating partner" });
    }
  };
  const fetchPartnersList = async () => {
    try {
      const res = await services.requestSvc.get("/partners");
      setPartnersList(res);
    } catch (error) {
      console.error("Error fetching partners list", error);
    }
  };
  const handleEdit = (partner) => {
    setEditingPartner(partner);
    setFormData({
      ...partner,
      activationStartDate: partner.activationStartDate.split("T")[0],
      activationEndDate: partner.activationEndDate?.split("T")[0] || "",
    });
  };
  useEffect(() => {
    fetchPartnersList();
  }, []);

  const columns = [
    {
      name: "",
      selector: "edit",
      cell: (row) => (
        <button className="text-blue-500" onClick={() => handleEdit(row)}>
          <FaEdit />
        </button>
      ),
    },
    { name: "Partner Id", selector: (row) => row.id },
    { name: "Partner Name", selector: (row) => row.name, wrap: true },
    {
      name: "Partner Spoc. Name",
      selector: (row) => row.contactPersonName,
      wrap: true,
    },
    {
      name: "Email",
      selector: (row) => row.contactPersonEmail,
      wrap: true,
    },
    {
      name: "Mobile",
      selector: (row) => row.contactPersonMobileNumber,
    },
  ];
  return (
    <div className="p-6">
      <h2 className="text-xl font-bold my-4">
        {editingPartner ? "Update" : "Create"} Partner
      </h2>

      {popup.show && (
        <div
          className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50"
          onClick={() => setPopup({ show: false, message: "" })}
        >
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <div className="flex justify-between items-center">
              <h3 className="font-bold text-lg">{popup.message}</h3>
            </div>
            <div className="mt-4 flex justify-center">
              <button
                onClick={() => setPopup({ show: false, message: "" })}
                className="btn-primary"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
      <form
        onSubmit={handleSubmit}
        className="grid grid-cols-1 md:grid-cols-2 gap-4"
      >
        <div className="flex flex-col">
          <label className="mb-2 text-gray-500">
            Organization Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="input-primary"
            required
            style={{
              borderRadius: "0px",
            }}
          />
        </div>
        <div className="flex flex-col">
          <label className="mb-2 text-gray-500">Organization Category</label>
          <select
            name="organizationCategory"
            value={formData.organizationCategory}
            onChange={handleChange}
            className="input-primary"
            style={{
              borderRadius: "0px",
            }}
          >
            <option value="">Select</option>
            <option value="sector_skill_council">Sector Skill Council</option>
            <option value="college">Private College</option>
            <option value="private_polytechnic">Private Polytechnic</option>
            <option value="private_ITI">Private ITI</option>
            <option value="private_university">Private University</option>
            <option value="private_school">Private School</option>
            <option value="private_college">Public College</option>
            <option value="public_polytechnic">Public Polytechnic</option>
            <option value="public_ITI">Public ITI</option>
            <option value="public_university">Public University</option>
            <option value="public_school">Public School</option>
            <option value="training_coaching_center">
              Training/ Coaching Center
            </option>
            <option value="social_organisation_ngo">
              Social Organisation/NGO
            </option>
            <option value="govt_department">Govt. Department</option>
            <option value="multi_national_corporation">
              Multi-national Corporation
            </option>
            <option value="indian_large_corporate">
              Indian Large Corporate
            </option>
            <option value="MSME">Indian MSME</option>
            <option value="other">Other</option>
          </select>
        </div>

        <textarea
          name="aboutPartner"
          value={formData.aboutPartner}
          onChange={handleChange}
          placeholder="About Partner"
          className="input-primary col-span-2"
          style={{
            borderRadius: "0px",
          }}
        />
        <div className="flex flex-col">
          <label className="col-span-1 text-gray-500">
            Activation Start Date
          </label>
          <input
            type="date"
            name="activationStartDate"
            value={formData.activationStartDate}
            onChange={handleChange}
            className="input-primary w-full"
            style={{
              borderRadius: "0px",
            }}
            required
          />
        </div>
        <div className="flex flex-col">
          <label className="col-span-1 text-gray-500">
            Activation End Date
          </label>
          <input
            type="date"
            name="activationEndDate"
            value={formData.activationEndDate}
            onChange={handleChange}
            className="input-primary w-full"
            required
            style={{
              borderRadius: "0px",
            }}
          />
        </div>

        <div className="flex flex-col mt-10">
          <label className="mb-2 text-gray-500">
            SPOC Person Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="contactPersonName"
            value={formData.contactPersonName}
            onChange={handleChange}
            className="input-primary"
            required
            style={{
              borderRadius: "0px",
            }}
          />
        </div>
        <div></div>

        <div className="flex flex-col">
          <label className="mb-2 text-gray-500">
            Email <span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            name="contactPersonEmail"
            value={formData.contactPersonEmail}
            onChange={handleChange}
            className="input-primary"
            required
            style={{
              borderRadius: "0px",
            }}
            pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}"
            title="Please enter a valid email address"
          />
        </div>
        <div className="flex flex-col">
          <label className="mb-2 text-gray-500">
            Mobile <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="contactPersonMobileNumber"
            value={formData.contactPersonMobileNumber}
            onChange={handleChange}
            className="input-primary"
            required
            style={{
              borderRadius: "0px",
            }}
            pattern="^[0-9]{10}$"
            title="Please enter a valid 10-digit mobile number"
          />
        </div>
        <div className="flex flex-col mt-10">
          <label className="mb-2 text-gray-500">Organization Head Name</label>
          <input
            type="text"
            name="organisationHeadName"
            value={formData.organisationHeadName}
            onChange={handleChange}
            className="input-primary"
            style={{
              borderRadius: "0px",
            }}
          />
        </div>
        <div></div>
        <div className="flex flex-col mb-10">
          <label className="mb-2 text-gray-500">Email</label>
          <input
            type="email"
            name="organisationHeadEmail"
            value={formData.organisationHeadEmail}
            onChange={handleChange}
            className="input-primary"
            style={{
              borderRadius: "0px",
            }}
            pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}"
            title="Please enter a valid email address"
          />
        </div>
        <div className="flex flex-col mb-10">
          <label className="mb-2 text-gray-500">Mobile</label>
          <input
            type="text"
            name="organisationHeadMobileNumber"
            value={formData.organisationHeadMobileNumber}
            onChange={handleChange}
            className="input-primary"
            style={{
              borderRadius: "0px",
            }}
            pattern="^[0-9]{10}$"
            title="Please enter a valid 10-digit mobile number"
          />
        </div>
        <div className="flex flex-col">
          <label className="mb-2 text-gray-500">Pincode</label>
          <input
            type="text"
            name="pinCode"
            value={formData.pinCode}
            onChange={handlePincodeChange}
            className="input-primary"
            style={{
              borderRadius: "0px",
            }}
          />
        </div>
        <div className="flex flex-col">
          <label className="mb-2 text-gray-500">Country</label>
          <input
            type="text"
            name="addressCountry"
            value={formData.addressCountry}
            className="input-primary"
            disabled
            style={{
              borderRadius: "0px",
            }}
          />
        </div>
        <div className="flex flex-col">
          <label className="mb-2 text-gray-500">State</label>
          <input
            type="text"
            name="addressState"
            value={formData.addressState}
            onChange={handleChange}
            className="input-primary"
            disabled
            style={{
              borderRadius: "0px",
            }}
          />
        </div>
        <div className="flex flex-col">
          <label className="mb-2 text-gray-500">City/Town</label>
          <input
            type="text"
            name="addressCityTown"
            value={formData.addressCityTown}
            onChange={handleChange}
            className="input-primary"
            style={{
              borderRadius: "0px",
            }}
          />
        </div>
        <div className="flex flex-col">
          <label className="mb-2 text-gray-500">District</label>
          <input
            type="text"
            name="addressDistrict"
            value={formData.addressDistrict}
            onChange={handleChange}
            className="input-primary"
            disabled
            style={{
              borderRadius: "0px",
            }}
          />
        </div>
        <div className="flex flex-col">
          <label className="mb-2 text-gray-500">Address</label>
          <input
            type="text"
            name="addressHouseNumber"
            value={formData.addressHouseNumber}
            onChange={handleChange}
            className="input-primary"
            style={{
              borderRadius: "0px",
            }}
          />
        </div>
        <div className="flex flex-col">
          <label className="mb-2 text-gray-500">Landmark</label>
          <input
            type="text"
            name="addressLocation"
            value={formData.addressLocation}
            onChange={handleChange}
            className="input-primary"
            style={{
              borderRadius: "0px",
            }}
          />
        </div>
        <div className="flex flex-col mt-4">
          <label className="text-gray-500">Partner Logo</label>
          <input
            type="file"
            onChange={handleFileChange}
            accept=".jpg,.jpeg,.png,.pdf"
            className="col-span-2"
          />
        </div>
        <label className="col-span-2 flex items-center  gap-2 text-gray-500">
          <input
            type="checkbox"
            name="active"
            checked={formData.active}
            onChange={handleChange}
            className="input-primary"
          />{" "}
          Active Partner
        </label>

        <button type="submit" className="px-4 py-2 btn-primary w-1/4">
          {editingPartner ? "Update" : "Create"}
        </button>
      </form>
      <hr className="mt-6" />
      {partnersList.length > 0 && (
        <div className="mt-6">
          <div className="flex ">
            <h3 className="text-lg font-bold mt-2">Partner List</h3>
            <h1 className="text-lg font-medium ml-20  text-[#2A6EC6] border border-gray-600 p-2">
              Total Partners:
              <span className="ml-2 text-red-500">{partnersList?.length}</span>
            </h1>
          </div>
          <div className="mt-6 overflow-x-auto">
            <DataTable
              columns={columns}
              data={partnersList || []}
              pagination
              paginationRowsPerPageOptions={[1, 5, 10, 15]}
              paginationPerPage={10}
              paginationTotalRows={partnersList?.length}
              customStyles={{
                table: {
                  style: {
                    overflow: "hidden",
                    borderRadius: "8px 8px 0px 0px",
                    border: "1px solid rgba(0,0,0,0.4)",
                    borderLeft: "0",
                  },
                },
                headRow: {
                  style: {
                    background: "#b1c7e9",
                    color: "#3D3D3D",
                    fontWeight: "600",
                    "&:hover": {
                      cursor: "pointer",
                    },
                  },
                },
                headCells: {
                  style: {
                    border: "1px solid rgba(0,0,0,0.4)",
                    borderTop: "0",
                    borderRight: "0",
                    borderBottom: "0",
                  },
                },
                cells: {
                  style: {
                    borderLeft: "1px solid rgba(0,0,0,0.4)",
                  },
                },
                rows: {
                  style: {
                    backgroundColor: "#fff",
                    cursor: "default",
                    color: "#656363",
                    fontSize: "14px",
                    "&:hover": {
                      cursor: "default",
                      backgroundColor: "#E9E9E9",
                    },
                    borderBottom: "1px solid rgba(0,0,0,0.4)",
                  },
                },
                pagination: {
                  style: {
                    backgroundColor: "rgba(0, 0, 0, 0.05)",
                    borderRadius: "0.375rem",
                    borderTopLeftRadius: "0px",
                    borderTopRightRadius: "0px",
                    border: "1px solid rgba(0,0,0,0.4)",
                    borderTop: "0",
                    fontWeight: "500",
                    color: "rgb(61, 61, 61)",
                  },
                },
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateUpdatePartner;
